import React from "react";
import "../styles/Footer.css";
import dadangkyImg from "../assets/images/dadangky.png";
import mastercImg from "../assets/images/masterc_logo.png";
import visaImg from "../assets/images/Visa_logo.png";
import logoHBCImg from "../assets/images/logo-HBC.png";

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer" id="lien-he">
            <div className="footer-main">
                {/* LEFT: Company Info */}
                <div className="footer-left">
                    <a href="/" className="footer-logo">
                        <img src={logoHBCImg} alt="Logo Công ty HBC" />
                    </a>
                    <div className="footer-company-name">
                        CÔNG TY CỔ PHẦN HÒA BÌNH
                    </div>
                    <div className="footer-address">
                        <span className="footer-icon">📍</span>
                        346-350 Đường Trần Văn Giàu, P.Tân Tạo, Q.Bình Tân, TP. Hồ Chí Minh
                    </div>
                    <div className="footer-contact-row">
                        <span className="footer-icon">📞</span>
                        (84-28) 37540187 – 37540188
                    </div>
                    <div className="footer-contact-row">
                        <span className="footer-icon">✉️</span>
                        <a href="mailto:info@hbc.com.vn">info@hbc.com.vn</a>
                    </div>
                    <div className="footer-contact-row">
                        <span className="footer-icon">🌐</span>
                        <a href="https://hbc.com.vn/" target="_blank" rel="noopener noreferrer">
                            hbc.com.vn
                        </a>
                    </div>
                    <div className="footer-social">
                        <a
                            href="https://www.facebook.com/hbc.com.vn"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link"
                            aria-label="Facebook"
                        >
                            <FacebookIcon />
                        </a>
                    </div>
                </div>

                {/* RIGHT: Hotline List */}
                <div className="footer-right">
                    <h3 className="hotline-title">DANH SÁCH HOTLINE</h3>
                    <div className="hotline-grid">
                        <div className="hotline-item">
                            <span className="hotline-name">TP HCM - Hoà Bình</span>
                            <a href="tel:1800646478" className="hotline-number">1800 646 478</a>
                        </div>
                        <div className="hotline-item">
                            <span className="hotline-name">Hà Nội - Tâm Bình</span>
                            <a href="tel:0329990912" className="hotline-number">0329 990 912</a>
                        </div>
                        <div className="hotline-item">
                            <span className="hotline-name">Quảng Nam - Hồng Hải Bình</span>
                            <a href="tel:0905107467" className="hotline-number">0905 107 467</a>
                        </div>
                        <div className="hotline-item">
                            <span className="hotline-name">Đắk Lắk - Gia Bình</span>
                            <a href="tel:0911450969" className="hotline-number">0911 450 969</a>
                        </div>
                        <div className="hotline-item">
                            <span className="hotline-name">Đồng Nai - An Khánh Bình</span>
                            <a href="tel:0903843188" className="hotline-number">0903 843 188</a>
                        </div>
                        <div className="hotline-item">
                            <span className="hotline-name">Long An - An Kiên Bình</span>
                            <a href="tel:02723952539" className="hotline-number">(0272) 3952 539</a>
                        </div>
                        <div className="hotline-item">
                            <span className="hotline-name">An Giang - Long Bình</span>
                            <a href="tel:0962595900" className="hotline-number">0962 595 900</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom bar */}
            <div className="footer-bottom">
                <div className="footer-bottom-inner">
                    <span>© {currentYear} Hòa Bình Corporation. Thiết kế bởi HBC Technology.</span>
                    <div className="payment-logos">
                        <img src={visaImg} alt="Visa" />
                        <img src={mastercImg} alt="MasterCard" />
                        <img src={dadangkyImg} alt="Đã đăng ký BCT" />
                    </div>
                </div>
            </div>
        </footer>
    );
}

const FacebookIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"></path>
    </svg>
);

export default Footer;
